<script setup lang="ts">
import { AppLinkButton } from '@libs/ui';

interface ProductCardFooterEmits {
  (eventName: 'show-details'): void;
  (eventName: 'mouse-enter'): void;
  (eventName: 'mouse-leave'): void;
}

const emit = defineEmits<ProductCardFooterEmits>();
</script>

<template>
  <div
    class="product-card-footer"
    @mouseenter="emit('mouse-enter')"
    @mouseleave="emit('mouse-leave')"
    @click="emit('show-details')"
  >
    <AppLinkButton
      :text="$t('planner.details')"
      size="large"
      @click="emit('show-details')"
    />
  </div>
</template>

<style scoped lang="scss">
.product-card-footer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-top: 1px solid var(--color-secondary-93);
  padding: var(--spacing-16);
}
</style>
